import React from "react";
import paths from "@icarius-router/paths";
import CommonPage from "@icarius-common/commonPage";
import CustomIconButton from "@icarius-common/abmComponents/customIconButton";
import { getLocalizedString } from "@icarius-localization/strings";
import useHistoricalDistributionCost from "./useHistoricalDistributionCost";

const Catalogs = ({ code, name, handleGoBack }) => {

  const {
    isLoading,
    data,
  } = useHistoricalDistributionCost(code);

  const goBackItem = () =>
    <CustomIconButton
      title={getLocalizedString("goBack")}
      onClick={handleGoBack}
      type={"goBack"}
    />

  return (
    <CommonPage
      isLoading={isLoading}
      title={`${getLocalizedString("historicalCostDistribution")} - ${name}`}
      gridTitle={getLocalizedString("historicalCostDistribution")}
      columnDefPage={paths.historicalDistributionCost}
      rowData={data}
      menuItems={[goBackItem]}
      hasExpand
      hasHelp
      ignoreProcessesbyPath
    />
  )
}

export default Catalogs;